<template>
  <section class="m-l-30 m-r-30 m-b-30">
    <div class="card card-1 relative-card">
       <span id="close-exports" @click="sendFiltersToParentComponent(true); hideExport();"><i class="fa fa-times-circle-o" aria-hidden="true"></i></span>
       <div class="card-body">
         <h3 >Search / Export Print Queue</h3>
         <p class="m-b-30 text-info">Please select at least one option to Search / Export Data</p>
         
         <b-row class="m-b-30">
           <b-col cols="6">
              <label for="">Date Range (Optional)</label>
              <date-range-picker 
              v-model="filters.dateRange"
              :timePicker="false"
              :timePicker24Hour="true"
              class="datePicker"
              :locale-data="localeData"
               ref="picker"
               @update="resetData(); sendFiltersToParentComponent()"
              >

              <!--    input slot (new slot syntax)-->
              <template #input="picker" style="min-width: 350px;">
                {{ picker.startDate | moment("ddd, MMM Do YYYY") }} - {{ picker.endDate | moment("ddd, MMM Do YYYY") }}
              </template>

              </date-range-picker>

        
           </b-col>
           <b-col cols="1">
             <div @click="resetDates" class="resetDateTrigger" v-if="filters.dateRange.startDate"><i class="fa fa-undo" aria-hidden="true"></i></div>
           </b-col>
           <b-col cols="5">
              <label for="">Select a Store (Optional)</label>
              <b-form-select v-model="filters.selectedStore" :options="stores" @change="resetData(); sendFiltersToParentComponent()"></b-form-select>
           </b-col>
           
         </b-row>
        <transition name="fade" mode="out-in">
            <b-row class="m-b-30 m-t-30"  v-if="filters.selectedStore">
              <b-col cols="12">
                  <div class="search-order-ids">
                    <label for="">Order Nos. separated by comma (Optional)</label>
                    <b-form-input class="input-fields" v-model="filters.orderNos" placeholder="Eg. OrderId01, OrderId02, OrderId03" @input="resetData" @change="sendFiltersToParentComponent()"></b-form-input>
                  </div>
              </b-col>
            </b-row>
        </transition>

         <b-row class="m-b-30">
           <b-col cols="4">
              <label for="">Product Name (Optional)</label>
              <b-form-input class="input-fields" block  v-model="filters.productName" @input="resetData" @change="sendFiltersToParentComponent();"></b-form-input>
           </b-col>
           <b-col cols="4">
              <label for="">Size / Type (Optional)</label>
              <b-form-input class="input-fields" block  v-model="filters.sizeOrType" @input="resetData" @change="sendFiltersToParentComponent();"></b-form-input>
           </b-col>
           <b-col cols="4">
              <label for="">Tags (Optional)</label>
              <b-form-input class="input-fields" block  v-model="filters.tags" @input="resetData" @change="sendFiltersToParentComponent();"></b-form-input>
           </b-col>
         </b-row>

         <b-row class="m-b-30 shipping-fields">
           <b-col cols="4">
              <label for="">Shipped From</label>
              <autocomplete
                placeholder="Set Country"
                :source="allCountries"
                @selected="shippedFromChanged"
                @clear="shippedFromCleared"
                >
              </autocomplete>
           </b-col>
           <b-col cols="4">
              <label for="">Shipped To</label>
               <autocomplete
                placeholder="Set Country"
                :source="allCountries"
                @selected="shippedToChanged"
                @clear="shippedToCleared"
                >
              </autocomplete>
           </b-col>

         </b-row>

         <div class="statusCheckboxes">

           <h4 class="text-center m-b-40 text-success">Make Combinations from both groups of checkboxes</h4>

           <b-row class="m-b-30">
             <b-col cols="12" class="text-center">
              <b-form-group label='Which statuses are "Active" for your search? (Optional)' v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    id="pq-active-statuses"
                    v-model="filters.activeStatuses"
                    :options="activeStatusOptions"
                    :aria-describedby="ariaDescribedby"
                    name="active-statuses"
                    variant="success"
                    @input="activeStatusesFn"
                  ></b-form-checkbox-group>
               </b-form-group>
             </b-col>
           </b-row>
           
           <b-row >
             <b-col cols="12" class="text-center">
              <b-form-group label='Which statuses are "Inactive" for your search? (Optional)' v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    id="pq-inactive-statuses"
                    v-model="filters.inactiveStatuses"
                    :options="inactiveStatusOptions"
                    :aria-describedby="ariaDescribedby"
                    name="inactive-statuses"
                    @input="inactiveStatusesFn"
                  ></b-form-checkbox-group>
               </b-form-group>
             </b-col>
           </b-row>
         </div>

         
         
         <a href="#" class="text-success m-b-10 d-inline-block m-t-10" @click.prevent="showExport = !showExport">{{ showExport ? 'Hide' : 'Show'}} Export Widget</a>
         <section class="export-section" v-if="showExport">
           <b-row>
             <b-col cols="6">
                <b-button variant="dark" block size="lg" @click="generatePrintQueueData" :disabled="!conditionsFoundForExport">
           
                   <div v-if="processingRequest">
                     <b-spinner small></b-spinner>
                     <span class="sr-only">Processing Request...</span>
                   </div>
           
                  <span v-else>Generate Data</span>
           
                  </b-button>
             </b-col>
             <b-col cols="6">
                <b-button :variant="this.exportData.length == 0 ? 'outline-dark' : 'danger'" block size="lg" @click="exportTheData" :disabled="this.exportData.length == 0">Download Data</b-button>
             </b-col>
           </b-row>
           <div class="text-danger text-center m-t-20" v-if="noDataFound">
              No Data found for these conditions.
           </div>
         </section>
       </div>
    </div>

    
  </section>
</template>

<script>
import StoreService from '../../services/store.service';
import DateRangePicker from 'vue2-daterange-picker'
import ItemListService from '../../services/item-list.service';

import xlsx from 'json-as-xlsx';
import EventBus from '../../EventBus';
import Autocomplete from 'vuejs-auto-complete'

//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  export default {
      data(){
        let startDate = null ;
        let endDate = null ;  
        return {
        showExport: false,
        processingRequest: false,
        noDataFound: false,
        exportData: [],
        stores: [{
              value: null,
              text: 'Select a store'
            }],
         filters: {
            productName: '',
            orderNos: '',
            selectedStore: null,
            dateRange: {startDate, endDate},
            activeStatuses: [],
            inactiveStatuses: [],
            sizeOrType: '',
            shippedFrom: {},
            shippedTo: {},
            tags: ''
         },
         localeData: {
          direction: 'ltr',
          format: 'mm/dd/yyyy',
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          firstDay: 0
         },
         activeStatusOptions: [
          { text: 'Active Print File Sent', value: 'Print File Sent' },
          { text: 'Active Print File Checked', value: 'Print File Checked' },
          { text: 'Active Print File Printed', value: 'Print File Printed' },
        ],
        inactiveStatusOptions: [
          { text: 'Inactive Print File Sent', value: 'Print File Sent' },
          { text: 'Inactive Print File Checked', value: 'Print File Checked' },
          { text: 'Inactive Print File Printed', value: 'Print File Printed' },
        ]
        }
      },
      components: {DateRangePicker, Autocomplete},
      mounted(){
        this.fetchStores()
      },
      computed: {
         conditionsFoundForExport(){
            if(!this.filters.productName && !this.filters.orderNos && !this.filters.selectedStore && !this.filters.dateRange.startDate && !this.filters.dateRange.endDate && this.filters.activeStatuses.length == 0 && this.filters.inactiveStatuses.length == 0 && !this.filters.sizeOrType && !this.filters.shippedFrom && !this.filters.shippedTo && !this.filters.tags){
               return false;
            }
            return true;
         },
         allCountries(){
            return this.$store.state.itemsList.countries
          }
      },
      methods: {
         resetDates(){
            this.filters.dateRange.startDate = null;
            this.filters.dateRange.endDate = null;
            this.sendFiltersToParentComponent(true)
         },
         fetchStores() {
          
          StoreService.fetchStores().then(response => {
                  let company_stores = response.data.data.map(store => {
                    return JSON.parse(JSON.stringify({
                      value: store.id,
                      text: store.identifier
                    }))
                  });
                  this.stores = this.stores.concat(company_stores);
                  
                })
                .catch(errors => console.log(errors))
                
         },
         async generatePrintQueueData(){
            try{
               this.processingRequest = true;
               const result = await ItemListService.exportPrintQueueData(this.filters)
               this.exportData = result.data.processedPrintQueueItems
               if(this.exportData.length > 0){
                  this.noDataFound = false;
               }else{
                  this.noDataFound = true;
               }
               this.processingRequest = false;
            }catch(errors){
              console.log(errors)
              this.processingRequest = false;
            }
         },
         exportTheData(){
           let data = [{
                  sheet: 'Print Queue', 
                  columns: [
                    {label: "Order No.", value: "order_no"},
                    {label: "Product Name", value: "product_name"},
                    {label: "Size or Type", value: "size_or_type"},
                    {label: "Created UTC", value: "creation_date_utc"},
                    {label: "Store Name", value: "store_name"},
                    {label: "Is Duplicate Entry", value: "is_a_duplicate"},
                    {label: "Print File Sent", value: "print_file_sent"},
                    {label: "Print FIle Sent UTC", value: "print_file_sent_date_time"},
                    {label: "Print File Checked", value: "print_file_checked"},
                    {label: "Print File Checked UTC", value: "print_file_checked_date_time"},
                    {label: "Print File Printed", value: "print_file_printed"},
                    {label: "Print File Printed UTC", value: "print_file_printed_date_time"},
                    {label: "Last Updated UTC", value: "last_updated_at_utc"},
                    {label: "Added By", value: "added_by"},
                    {label: "Tags", value: "tags"},
                  ],
                  content: this.exportData,
                }];
                let settings = {
                    fileName: 'Print Queue Exported Data'
                  }
                xlsx(data, settings)
         },
         resetData(){
           this.exportData = []
         },
         hideExport(){
            this.$store.dispatch('itemsList/updateIsExportActiveAction', false)
         },
         activeStatusesFn(){
            this.filters.activeStatuses.forEach(status => {
                 console.log(status)
                 const index = this.filters.inactiveStatuses.indexOf(status);
                  if (index > -1) {
                    this.filters.inactiveStatuses.splice(index, 1);
                  }
            });

            this.sendFiltersToParentComponent()
         },
         inactiveStatusesFn(){
            this.filters.inactiveStatuses.forEach(status => {
                 console.log(status)
                 const index = this.filters.activeStatuses.indexOf(status);
                  if (index > -1) {
                    this.filters.activeStatuses.splice(index, 1);
                  }
            });
            this.sendFiltersToParentComponent()
         },
         sendFiltersToParentComponent(sendNull=false){
             if(sendNull){
                EventBus.$emit('print-queue.filters-updated', null)
             }
             else if(!this.filters.productName && !this.filters.orderNos && !this.filters.selectedStore && !this.filters.dateRange.startDate && !this.filters.dateRange.endDate && this.filters.activeStatuses.length == 0 && this.filters.inactiveStatuses.length == 0 && !this.filters.sizeOrType && !this.filters.shippedFrom && !this.filters.shippedTo && !this.filters.tags){
               EventBus.$emit('print-queue.filters-updated', null)
             }
             else{
                EventBus.$emit('print-queue.filters-updated', this.filters)
             }
             
         },
         shippedFromChanged(countryData){
           console.log("Shipped From", countryData)
          this.filters.shippedFrom = {
                  name: countryData.display,
                  id: countryData.value
            }
           
           this.sendFiltersToParentComponent();
           this.resetData(); 
         },
          shippedToChanged(countryData){
           console.log("Shipped To", countryData)
          this.filters.shippedTo= {
                  name: countryData.display,
                  id: countryData.value
            }
           
           this.sendFiltersToParentComponent();
           this.resetData(); 
         },
         shippedFromCleared(){
           this.filters.shippedFrom = {}
           this.sendFiltersToParentComponent();
           this.resetData(); 
         },
         shippedToCleared(){
           this.filters.shippedTo = {}
           this.sendFiltersToParentComponent();
           this.resetData(); 
         }
      }
  }
</script>

<style lang="scss" scoped>
  .input-fields{
    height: 40px;
    border-radius: 5px;
  }
  .resetDateTrigger{
     cursor: pointer;
     font-size: 20px;
     color: rgb(16, 190, 16);
     margin-top: 38px;
  }
  .relative-card{
    position: relative;
  }
  #close-exports{
    position: absolute;
    right: 10px;
    top: 10px;
    color: rgb(255, 72, 72);
    font-size: 30px;
    cursor: pointer;
    line-height: 0;
  }
  .export-section{
    padding: 20px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
  }
  .statusCheckboxes{
     border: 1px dashed rgb(161, 210, 255);
     padding: 25px;
  }
  .search-order-ids{
    background-color: rgb(228, 248, 255);
    border: 1px solid rgb(185, 233, 250);
    padding: 20px;
  }
</style>